import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import SelectAvtar from "./SelectAvtar";
import SelectImageFromGallery from "./SelectImageFromGallery";
import { ClipLoader } from "react-spinners";
import useApiPost from "../../../hooks/PostData";
import { updateUserData } from "../../../store/Slices/UserSlice";
import { useFile } from "../../../context/FileProvider";
import TextTranslate from "../../../utils/TextTranslate";
import { UserDataRes } from "../../../types/UserDataType";

export default function ChangeProfileImageModal() {
  const dispatch = useAppDispatch();
  const ViewManager = useAppSelector((state) => state.ViewManager);
  const userData = useAppSelector((state) => state.userData);
  const { loading, postData } = useApiPost();
  const { selectedFile } = useFile();

  function close() {
    dispatch(updateViewState({ showChangeProfileModal: false }));
  }

  async function updateUserDetails() {
    try {
      const userDetailsFormData = new FormData();

      if (selectedFile) {
        userDetailsFormData.append("files", selectedFile!);
        userDetailsFormData.append("pictureType", "profile_pic");
      } else if (userData.avatar_path != "") {
        userDetailsFormData.append("avatarUrl", String(userData.avatar_path));
        userDetailsFormData.append("pictureType", "avatar");
      } else {
        userDetailsFormData.append("dummy", "dummy");
      }

      const updateGroupProfile: UserDataRes = await postData(
        "users/updateUser",
        userDetailsFormData,
        "multipart/form-data",
      );

      dispatch(updateViewState({ showChangeProfileModal: false }));
      dispatch(updateUserData(updateGroupProfile.data));
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Dialog
      open={ViewManager.showChangeProfileModal}
      as="div"
      className="relative z-[100]"
      onClose={close}
    >
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm">
        <div className="flex min-h-full items-end justify-center p-0 sm:items-center sm:p-4">
          <DialogPanel className="relative flex max-h-[85dvh] w-full max-w-md flex-col overflow-hidden rounded-t-[1.25rem] bg-primary shadow-2xl sm:rounded-2xl">
            <DialogTitle className="shrink-0 border-b border-black/[0.06] px-4 py-3.5 text-center text-[17px] font-semibold tracking-tight text-darkText dark:border-white/[0.08]">
              <TextTranslate text="Pick your Avtar or select photo" />
            </DialogTitle>

            <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-4 py-4">
              <SelectAvtar />
              <div className="flex items-center gap-3 px-1">
                <div className="h-px flex-1 bg-black/[0.08] dark:bg-white/10" />
                <span className="text-[13px] font-medium uppercase tracking-wide text-lightText">
                  <TextTranslate text="OR" />
                </span>
                <div className="h-px flex-1 bg-black/[0.08] dark:bg-white/10" />
              </div>
              <SelectImageFromGallery />
            </div>

            <div className="shrink-0 border-t border-black/[0.06] bg-primary/95 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl dark:border-white/[0.08]">
              <div className="grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={close}
                  className="rounded-xl bg-black/[0.06] py-3 text-[17px] font-medium text-darkText transition active:scale-[0.99] dark:bg-white/10"
                >
                  <TextTranslate text="Cancel" />
                </button>
                <button
                  type="button"
                  onClick={() => void updateUserDetails()}
                  className="rounded-xl bg-themeColor py-3 text-[17px] font-semibold text-themeTextColor transition active:scale-[0.99]"
                >
                  {loading ? (
                    <ClipLoader size={18} color="currentColor" />
                  ) : (
                    <TextTranslate text="Submit" />
                  )}
                </button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
